import { langFile } from '../config/language.js'

export default {
  data() {
    return {
      lang: langFile
    }
  }
}
